import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Link } from "@mui/material";

interface IProps {
  url: string;
  invoiceId: string;
}

export default function InvoicePopup(props: Readonly<IProps>) {
  const { url, invoiceId } = props;
  const [open, setOpen] = useState(false);

  const onOpen = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    setOpen(true);
  };

  const onClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    setOpen(false);
  };

  return (
    <>
      <Link onClick={onOpen} component="button">
        {invoiceId}
      </Link>
      <Dialog
        data-testid="confirm-popup"
        open={open}
        onClose={onClose}
        onClick={(event) => event.stopPropagation()}
      >
        <DialogTitle>Tax Invoice</DialogTitle>
        <DialogContent sx={{ minWidth: { xs: "100%", sm: "500px" } }}>
          <Box
            sx={{
              border: "1px solid #ccc",
              height: "70vh",
              width: "100%",
              mb: 2,
            }}
          >
            <iframe
              src={`https://docs.google.com/gview?url=${url}&embedded=true`}
              title="Invoice PDF"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            p: "0 22px 22px 22px",
            gap: 1,
          }}
        >
          <Button onClick={onClose} color="inherit" sx={{ minWidth: "81px" }}>
            Close
          </Button>

          <Link
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontSize: "13px",
              fontWeight: "500",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            Download
          </Link>
        </DialogActions>
      </Dialog>
    </>
  );
}
